// El protocolo de la API SIGUE al de la página para evitar "Mixed Content":
// si la web se sirve por HTTPS, la API va por HTTPS; si por HTTP, por HTTP.
const protocol = (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') ? 'https' : 'http';
const _urls = {
  PROD: {
    nestApi: `${protocol}://${window.location.host}/api/v3`,
    axiosApi: `${protocol}://${window.location.host}/api/v4`,
    inveApi: `${protocol}://${window.location.host}/api/v5`,
    akdeApi: process.env.REACT_APP_API_AKDEMIC || 'https://api.uigv.edu.pe/api/',
    seguridadApi: 'https://api-seguridad.sunat.gob.pe/v1/',
    sireVentasApi: 'https://api-sire.sunat.gob.pe/v1/contribuyente/migeigv/libros/rvie'
  },
  DEV: {
    nestApi: 'http://localhost:8003/',
    axiosApi: 'http://localhost:8004/',
    inveApi: 'http://localhost:8005/',
    akdeApi: 'https://api.uigv.edu.pe/api/',
    seguridadApi: 'https://api-seguridad.sunat.gob.pe/v1/',
    sireVentasApi: 'https://api-sire.sunat.gob.pe/v1/contribuyente/migeigv/libros/rvie'
  }
}

export const mainUrls = _urls[process.env.REACT_APP_ENVI]
